module.exports = __webpack_public_path__ + "img/real-estate-team.7f9be433.png";